<div class="row col-12 p-0 m-0 main-page-section ">
  <div class="col-12 p-0 overview-icon profile-section">
    <div class="">
      <div class="breadcrumbs-section ">
        <span class="prev" routerLink="/overview">Home</span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="current">Profile</span>
      </div>
    </div>
    <!-- <div class="d-flex justify-content-between pb-3 col-12 padding-left-employees padding-right-employees">
      <div class="profile">
        Profile
      </div>
      <div class="log-out d-flex justify-content-end pointer-link" (click)="logout()">
        Log Out
      </div>
    </div> -->
    <div class="accor-padding-left">
      <div class="d-flex justify-content-between pb-3 col-12 p-0" style="width: 88%;">
        <div class="profile">
          Profile
        </div>
        <div class="log-out d-flex justify-content-end ">
          <!-- Log Out -->
          <div class="dots pointer-link" (click)="profileDrawer=!profileDrawer">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="drawer" *ngIf="profileDrawer">
          <div class="drawer-label-container">
            <div class='drawer-label' (click)="navigate()">Change Password</div>
            <div class='drawer-label' (click)="logout()">Logout</div>
          </div>
        </div>
      </div>
      <ngb-accordion [closeOthers]="true" activeIds="toggle-1" id="classChange" class="accordian-panel">
        <ngb-panel id="toggle-1">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="d-flex align-items-center justify-content-between w-100 position-relative accordion-header-row">
              <button id="toggle-1-header" ngbPanelToggle (click)="accodionClick('toggle-1-header', opened)"
                class="accordian-heading-color bg-none text-left pt-4 pl-4 pr-4 pb-0 outline-none border-0 flex-grow-1 text-left"
                [class.open-state]="opened">
                <span class="admin pl-3"> Admin</span>
              </button>
              <button ngbPanelToggle *ngIf="!opened" class="btn btn-link p-0 accordian-button"
                (click)="accodionClick('toggle-1-header', opened)"><img class="minus-image"
                  src="/assets/images/BackCopy.png" loading="lazy" /></button>
              <button ngbPanelToggle *ngIf="opened" class="btn btn-link p-0 accordian-button"
                (click)="accodionClick('toggle-1-header', opened)"><img src="/assets/images/BackCopy.png"
                  loading="lazy" /></button>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div class="accordion-sub-data pl-4 pr-4 pb-4 pt-0">
              <div class="col-12 row d-flex ">

                <div class="col-4 flex-column pt-3">
                  <div class="d-flex flex-column">
                    <span class="name">
                      Name
                    </span>

                    <span class="details">
                      {{taDetails?.name}}
                    </span>
                  </div>

                  <div class="d-flex flex-column pt-4 white-space">
                    <span class="name">
                      Mobile Number
                    </span>
                    <span class="details">
                      +91 {{taDetails?.mobileNumber}}

                    </span>
                  </div>
                </div>
                <div class="col-5 flex-column pt-3 pl-5 ml-3">
                  <div class="d-flex flex-column white-space">
                    <span class="name">
                      Email Id
                    </span>
                    <span class="details">
                      {{taDetails?.emailId | lowercase}}
                    </span>
                  </div>
                  <div class="d-flex flex-column pt-4 white-space">
                    <span class="name">
                      Department
                    </span>
                    <span class="details">
                      {{taDetails?.department}}
                    </span>
                  </div>

                </div>

                <div class="col-2 ml-5 d-flex justify-content-end">
                  <div class="circle-image-position" style="margin-top: 9px;">
                    <div class="circle">
                      <div class="circle-name">{{initials}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <div class="line"></div>
              </div>
              <div class="mt-5">
                <div class=" admin">
                  Access
                </div>
                <div class="entry-gate pt-3" *ngIf="accessPointList?.list.length > 0"> Entry Gate</div>
              </div>
              <div class="mt-4" *ngIf="accessPointList?.list.length > 0">
                <div class="pl-3 row d-flex mt-3 mr-3">
                  <ng-container class="" *ngFor="let eg of entryGate;let i=index">
                    <div class="chip" [ngClass]="(eg.selected)?'chip-selected':'chip-deselected'">
                      {{eg.accessPoint.accessPointName}}
                      <!-- <span class="closebtn">&times;</span> -->
                    </div>
                  </ng-container>


                </div>
              </div>
              <div class="show-all pt-3 pointer-link" (click)="showAccess(false)"
                [className]="accessPointList?.list.length > 0 ? 'enabled': 'disabled' ">Show all Access
                ({{accessPointList?.list.length}})</div>
            </div>
          </ng-template>
        </ngb-panel>
        <ngb-panel id="toggle-2">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="d-flex align-items-center justify-content-between w-100 position-relative accordion-header-row">
              <button id="toggle-2-header" ngbPanelToggle (click)="drawerClick(1, opened); accodionClick('toggle-2-header', opened)"
                class="accordian-heading-color bg-none text-left pt-4 pl-4 pr-4 pb-0 outline-none border-0 flex-grow-1 text-left"
                [class.open-state]="opened">
                <span class="admin pl-3"> Co-Admin 1</span>
              </button>
              <button ngbPanelToggle *ngIf="!opened && !isCoAdmin1Exists"
                class="btn btn-link p-0 add-button add accordian-button"
                (click)="drawerClick(1, opened);accodionClick('toggle-2-header', opened)"> Add Details</button>
              <button ngbPanelToggle *ngIf="opened || isCoAdmin1Exists"
                class="btn btn-link p-0 accordian-button"
                (click)="accodionClick('toggle-2-header', opened)"><img [ngClass]="{'minus-image': !opened}"
                  src="/assets/images/BackCopy.png" loading="lazy" (click)="drawerClick(null, opened)" /></button>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div class="accordion-sub-data pl-4 pr-4 pb-4 pt-0">
              <div>

                <div *ngIf="add1">
                  <div class="row">
                    <div class="col-10">
                      <div class="d-flex justify-textbox  mt-4">
                        <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'"
                          [class.error-input]="fieldErrors.includes('name1')" class="search-line   placeholder-text"
                          [(ngModel)]="fullname1" [placeholder]="!name ? 'Full Name' : ''" (click)="enterName('name')"
                          pattern="^[a-zA-Z ]{2,50}$" required (blur)="enterName('name')"
                          (ngModelChange)="inputModelChange(1,'name1')">
                        <label *ngIf="name" class="form-lable-email" for="mobile-emailid">Full Name</label>

                        <input type="email" [ngClass]="email?'textbox-onselect':'textbox-style'"
                          [class.error-input]="fieldErrors.includes('email1')"
                          class="search-line placeholder-text" [(ngModel)]="emailId1"
                          [placeholder]="!email ? 'Email ID' : ''" (click)="enterName('email')"
                          (blur)="enterName('email')" maxlength="50"
                          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" required
                          (ngModelChange)="inputModelChange(1, 'email1')">
                        <label *ngIf="email" class="form-lable-email" for="mobile-emailid">Email ID</label>
                      </div>

                      <div class="row" *ngIf="fieldErrors.length > 0">
                        <div class="col-5 field-error"><span
                            *ngIf="fieldErrors.includes('name1') && !fieldErrors.includes('name1len')">Please enter
                            valid
                            name</span>
                          <span *ngIf="fieldErrors.includes('name1len')">Please enter not more
                            than 50 characters</span>
                        </div>
                        <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('email1')">Please enter valid
                            email</span> </div>
                      </div>

                      <div class="d-flex justify-textbox  mt-4">

                        <span class="prefix" id="prefix"></span>
                        <input type="tel" [ngClass]="mobile?'textbox-onselect-mobile':'textbox-style'"
                          class="search-line  placeholder-text " [placeholder]="!mobile ? 'Mobile Number' : ''"
                          (click)="enterName('mobile')" (blur)="enterName('mobile')" required
                          (keyup)="inputModelChange(1, 'phone1')" pattern="^\d{10}$" maxlength="10" minlength="10"
                          [class.error-input]="fieldErrors.includes('phone1')" [(ngModel)]="phoneNumber1">
                        <label *ngIf="mobile" class="form-lable-mobile" for="mobile-emailid">Mobile Number</label>

                        <div class="textbox-style pointer-link" style="position: relative;">
                          <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                            [ngbPopover]="popContent" triggers="manual" #p="ngbPopover"
                            (click)="openPopover(p);enterName('department')" placement="bottom"
                            popoverClass='dash-popover dashboard-popover'>
                            <input class="pt-3 pb-3 input-width placeholder-text pointer-link"
                              [placeholder]="!dept ? 'Department' : ''" readonly [(ngModel)]="departmentName1" required
                              [class.error-input-dept]="fieldErrors.includes('dept1')">
                            <img src="/assets/images/Path.png" class="image-pos padding-left-image pr-1"
                              loading="lazy" />
                          </div>
                          <label *ngIf="dept" class="form-lable-dept" for="mobile-emailid">Department</label>

                          <div>
                            <ng-template #popContent>
                              <!-- <div class="search p-0 m-0"> -->
                              <div class="template p-0 m-0">
                                <div class="popupHeader">
                                  <img src="../../assets/images/search.png">
                                  <input type="text" placeholder='Search' [(ngModel)]="searchDept" />
                                </div>
                                <div class="dashboard-popover ">
                                  <div class="d-flex justify-content-between">
                                    <div class="pl-3 pt-3 pr-3 pb-3 ">
                                      <div class="row pb-2"
                                        *ngFor="let dept of deptList | ListFilter: searchDept;let index =i"
                                        (click)="setDepartment1(dept);openPopover(p);inputModelChange(1, 'dept1')">
                                        <div class="popover-content normal-font pl-3 email-width">
                                          {{dept.department}}
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </div>
                        </div>

                      </div>
                      <div class="row" *ngIf="fieldErrors.length > 0">
                        <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('phone1')">Please enter valid
                            mobile number</span>
                        </div>
                        <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('dept1')">Please select a
                            department</span>
                        </div>
                      </div>


                    </div>
                    <div class="col-2" style="margin: auto;">
                      <div class="profil-pic-holder" [style.background-color]="initials1 == '' ? '#fff': '#d2edf0'">
                        <img *ngIf="initials1 == ''"
                          [src]="(coAdmin1?.profileUrl == null || coAdmin1?.profileUrl == '') ? '/assets/images/profile/default-user.png' : coAdmin1?.profileUrl"
                          alt="coadmin profile image">
                        <div class="profil-pic-initial"
                          *ngIf="initials1 != '' && (coAdmin1?.profileUrl == null || coAdmin1?.profileUrl !== '')">
                          <span>{{initials1}}</span>
                        </div>
                      </div>

                    </div>
                  </div>


                  <div class="">
                    <div class="line "></div>
                  </div>
                  <div>
                    <div class="mt-3">
                      <div class=" admin">
                        Access
                      </div>
                      <div class="entry-gate pt-3" *ngIf="accessPointList?.list.length > 0"> Entry Gate</div>
                    </div>
                    <div class="mt-4" *ngIf="accessPointList?.list.length > 0">
                      <div class="pl-3 row d-flex mt-3 mr-3">
                        <ng-container class="" *ngFor="let mr of entryGate;let i=index">
                          <div class="chip" [ngClass]="(mr.selected)?'chip-selected':'chip-deselected'"
                            (click)="changeAccess(mr,'entryGate',i)">
                            {{mr.accessPoint.accessPointName}}
                            <!-- <span class="closebtn" (click)="changeAccess(mr,'entryGate', i, true)">&times;</span> -->
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div class="show-all pt-3 pointer-link" (click)="showAccess(true)"
                      [className]="accessPointList?.list.length > 0 ? 'enabled': 'disabled' ">Show all Access
                      ({{accessPointList?.list.length}})</div>

                    <div class="">
                      <div class="line "></div>
                    </div>
                    <div class="pt-4" *ngIf="add1 && isAdmin == '1'">
                      <span>
                        <button type="button " class="add-button" (click)="addClick('add', 1, $event)"
                          [disabled]="disableAdd"><span class="add">Save</span></button>
                      </span>
                      <button type="button " class="cancel-button pl-3" ngbPanelToggle (click)="cancelAdd()"><span
                          class="cancel">Cancel</span></button>
                    </div>
                  </div>
                </div>
                <div *ngIf="!add1">
                  <div class="row">
                    <div class="col-10">
                      <div class="row d-flex ">
                        <div class="col-12">
                          <div class="col-9 row">
                            <div class="col-6 flex-column pt-3">
                              <div class="d-flex flex-column">
                                <span class="name">
                                  Co-Admin Name
                                </span>

                                <span class="details">
                                  {{fullname1}}
                                </span>
                              </div>

                              <div class="d-flex flex-column pt-4 white-space">
                                <span class="name">
                                  Mobile Number
                                </span>
                                <span class="details">
                                  +91 {{phoneNumber1}}
                                </span>
                              </div>
                            </div>
                            <div class="col-6 flex-column pt-3">
                              <div class="d-flex flex-column white-space">
                                <span class="name">

                                  Email Id
                                </span>
                                <span class="details">

                                  {{emailId1 | lowercase}}
                                </span>
                              </div>

                              <div class="d-flex flex-column pt-4 white-space">
                                <span class="name">
                                  Department
                                </span>
                                <span class="details">
                                  {{departmentName1}}
                                </span>
                              </div>

                            </div>
                          </div>
                          <div class="col-3"></div>

                        </div>



                      </div>
                    </div>
                    <div class="col-2" style="margin: auto;">
                      <div class="profil-pic-holder"
                        [style.background-color]="(coAdmin1?.profileUrl != null && coAdmin1?.profileUrl != '') ? '#fff': '#d2edf0'">
                        <img *ngIf="coAdmin1?.profileUrl != null && coAdmin1?.profileUrl != ''"
                          [src]="(coAdmin1?.profileUrl == null || coAdmin1?.profileUrl == '') ? '/assets/images/profile/default-user.png' : coAdmin1?.profileUrl"
                          alt="coadmin profile image">
                        <div class="profil-pic-initial">
                          <span
                            *ngIf="initials1 != '' && (coAdmin1?.profileUrl == null || coAdmin1?.profileUrl !== '')">{{initials1}}</span>
                        </div>
                      </div>

                    </div>
                    <div class="col-12">
                      <div class="">
                        <div class="line "></div>
                      </div>
                      <div class="mt-3">
                        <div class=" admin">
                          Access
                        </div>
                        <div class="entry-gate pt-3" *ngIf="accessPointList?.list.length > 0"> Entry Gate</div>
                      </div>
                      <div class="mt-4" *ngIf="accessPointList.list?.length > 0">
                        <div class="pl-3 row d-flex mt-3 mr-3">
                          <ng-container class="" *ngFor="let mr of entryGate;let i=index">
                            <div class="chip" [ngClass]="(mr.selected)?'chip-selected':'chip-deselected'"
                              (click)="changeAccess(eg,'entryGate',i)">
                              {{mr.accessPoint.accessPointName}}
                              <!-- <span class="closebtn">&times;</span> -->
                            </div>
                          </ng-container>
                        </div>
                      </div>
                      <div class="show-all pt-3 pointer-link" (click)="showAccess(false)"
                        [className]="accessPointList?.list.length > 0 ? 'enabled': 'disabled' ">Show all Access
                        ({{accessPointList?.list.length}})</div>

                      <div class="">
                        <div class="line "></div>
                      </div>
                      <div class="pt-4" *ngIf="isAdmin == '1'">
                        <span>
                          <button type="button " class="add-button"
                            (click)="addClick('edit', 1, $event);drawerClick(1)"><span class="add">Edit</span></button>
                        </span>
                        <button type="button " class="cancel-button pl-3"
                          (click)="drawerClick(null); removeCoAdmin(1)"><span class="cancel">Remove Co-Admin
                            1</span></button>
                      </div>
                    </div>
                  </div>


                </div>

              </div>


            </div>
          </ng-template>
        </ngb-panel>
        <ngb-panel id="toggle-3" *ngIf="isCoAdmin2Exists || isAdmin == '1'">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="d-flex align-items-center justify-content-between w-100 position-relative accordion-header-row">
              <button id="toggle-3-header" ngbPanelToggle (click)="drawerClick(2,opened);accodionClick('toggle-3-header', opened)"
                class="accordian-heading-color bg-none text-left pt-4 pl-4 pr-4 pb-0 outline-none border-0 flex-grow-1 text-left"
                [class.open-state]="opened">
                <span class="admin pl-3"> Co-Admin 2</span>
              </button>
              <button ngbPanelToggle *ngIf="!opened && !isCoAdmin2Exists"
                class="btn btn-link p-0 add-button add accordian-button"
                (click)="drawerClick(2,opened);accodionClick('toggle-3-header', opened)"> Add Details</button>
              <button ngbPanelToggle *ngIf="opened || isCoAdmin2Exists"
                class="btn btn-link p-0 accordian-button"
                (click)="accodionClick('toggle-3-header', opened)"><img [ngClass]="{'minus-image': !opened}"
                  src="/assets/images/BackCopy.png" loading="lazy" (click)="drawerClick(null,opened)" /></button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="accordion-sub-data pl-4 pr-4 pb-4 pt-0">
              <div>
                <!-- <div class=" access pt-3">
                  Co-Admin2
                </div> -->
                <div *ngIf="add2">
                  <div class="row">
                    <div class="col-10">
                      <div class="d-flex justify-textbox  mt-4">
                        <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'"
                          class="search-line   placeholder-text" [(ngModel)]="fullname2" pattern="^[a-zA-Z ]{2,50}$"
                          [placeholder]="!name ? 'Full Name' : ''" (click)="enterName('name2')"
                          (ngModelChange)="inputModelChange(2, 'name2')" required (blur)="enterName('name2')"
                          [class.error-input]="fieldErrors.includes('name2')">
                        <label *ngIf="name" class="form-lable-email" for="mobile-emailid">Full Name</label>

                        <input type="email" [ngClass]="email?'textbox-onselect':'textbox-style'"
                          class="search-line  placeholder-text" [(ngModel)]="emailId2"
                          [placeholder]="!email ? 'Email ID' : ''" (click)="enterName('email2')"
                          (blur)="enterName('email2')" required
                          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                          (ngModelChange)="inputModelChange(2, 'email2')"
                          [class.error-input]="fieldErrors.includes('email2')">
                        <label *ngIf="email" class="form-lable-email" for="mobile-emailid">Email ID</label>
                      </div>


                      <div class="row" *ngIf="fieldErrors.length > 0">
                        <div class="col-5 field-error"><span
                            *ngIf="fieldErrors.includes('name2') && !fieldErrors.includes('name2len')">Please enter
                            valid
                            name</span>
                          <span *ngIf="fieldErrors.includes('name2len')">Please enter not more
                            than 50 characters</span>
                        </div>
                        <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('email2')">Please enter valid
                            email</span> </div>
                      </div>
                      <div class="row" *ngIf="fieldErrors.length > 0">
                        <div class="col-5 field-error"><span
                            *ngIf="fieldErrors.includes('name1') && !fieldErrors.includes('name1len')">Please enter
                            valid
                            name</span>
                          <span *ngIf="fieldErrors.includes('name1len')">Please enter not more
                            than 50 characters</span>
                        </div>
                      </div>

                      <div class="d-flex justify-textbox  mt-4">
                        <span class="prefix" id="prefix"></span>
                        <input type="tel" [ngClass]="mobile?'textbox-onselect-mobile':'textbox-style'"
                          class="search-line  placeholder-text " [placeholder]="!mobile ? 'Mobile Number' : ''"
                          (click)="enterName('mobile2')" required (blur)="enterName('mobile2')"
                          (keyup)="inputModelChange(2, 'phone2')" pattern="^\d{10}$" maxlength="10" minlength="10"
                          [class.error-input]="fieldErrors.includes('phone2')" [(ngModel)]="phoneNumber2">
                        <label *ngIf="mobile" class="form-lable-mobile" for="mobile-emailid">Mobile Number</label>

                        <div class="textbox-style pointer-link" style="position: relative;">
                          <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                            [ngbPopover]="popContent" triggers="manual" #p="ngbPopover"
                            (click)="openPopover(p);enterName('department')" placement="bottom"
                            popoverClass='dash-popover dashboard-popover'>
                            <input class="pt-3 pb-3 input-width placeholder-text pointer-link"
                              [placeholder]="!dept ? 'Department' : ''" readonly [(ngModel)]="departmentName2" required
                              [class.error-input-dept]="fieldErrors.includes('dept2')">
                            <img src="/assets/images/Path.png" class="image-pos padding-left-image pr-1"
                              loading="lazy" />
                          </div>
                          <label *ngIf="dept" class="form-lable-dept" for="mobile-emailid">Department</label>

                          <div>
                            <ng-template #popContent>
                              <div class="template p-0 m-0">
                                <div class="popupHeader">
                                  <img src="../../assets/images/search.png">
                                  <input type="text" placeholder='Search' [(ngModel)]="searchDept" />
                                </div>

                                <div class="dashboard-popover ">
                                  <div class="d-flex justify-content-between">
                                    <div class="pl-3 pt-3 pr-3 pb-3 ">
                                      <div class="row pb-2"
                                        *ngFor="let dept of deptList | ListFilter: searchDept;let index =i"
                                        (click)="setDepartment2(dept);openPopover(p);inputModelChange(2, 'dept2')">
                                        <div class="popover-content normal-font pl-3 email-width">
                                          {{dept.department}}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </div>
                        </div>

                      </div>
                      <div class="row" *ngIf="fieldErrors.length > 0">
                        <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('phone2')">Please enter valid
                            mobile number</span>
                        </div>
                        <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('dept2')">Please select a
                            department</span>
                        </div>
                      </div>



                    </div>

                    <div class="col-2" style="margin: auto;">
                      <div class="profil-pic-holder" [style.background-color]="initials2 == '' ? '#fff': '#d2edf0'">
                        <img *ngIf="initials2 == ''"
                          [src]="(coAdmin2?.profileUrl == null || coAdmin2?.profileUrl == '') ? '/assets/images/profile/default-user.png' : coAdmin2?.profileUrl"
                          alt="coadmin profile image">
                        <div class="profil-pic-initial"
                          *ngIf="initials2 != '' && (coAdmin2?.profileUrl == null || coAdmin2?.profileUrl !== '')">
                          <span>{{initials2}}</span>
                        </div>
                      </div>

                    </div>


                  </div>

                  <div class="">
                    <div class="line "></div>
                  </div>
                  <div>
                    <div class="mt-3">
                      <div class=" admin">
                        Access
                      </div>
                      <div class="entry-gate pt-3" *ngIf="accessPointList?.list.length > 0"> Entry Gate</div>
                    </div>
                    <div class="mt-4" *ngIf="accessPointList?.list.length > 0">
                      <div class="pl-3 row d-flex mt-3 mr-3">
                        <ng-container class="" *ngFor="let mr of entryGate;let i=index">
                          <div class="chip" [ngClass]="(mr.selected)?'chip-selected':'chip-deselected'"
                            (click)="changeAccess(mr,'entryGate',i)">
                            {{mr.accessPoint.accessPointName}}
                            <!-- <span class="closebtn">&times;</span> -->
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div class="show-all pt-3 pointer-link" (click)="showAccess(true)"
                      [className]="accessPointList?.list.length > 0 ? 'enabled': 'disabled' ">Show all Access
                      ({{accessPointList?.list.length}})</div>

                    <div class="">
                      <div class="line "></div>
                    </div>
                    <div class="pt-4" *ngIf="add2 && isAdmin == '1'">
                      <span>
                        <button type="button " class="add-button" (click)="addClick('add',2, $event)"
                          [disabled]="disableAdd"><span class="add">Save</span></button>
                      </span>
                      <button type="button " class="cancel-button pl-3" ngbPanelToggle (click)="cancelAdd()"><span
                          class="cancel">Cancel</span></button>
                    </div>
                  </div>
                </div>
                <div *ngIf="!add2">
                  <div class="col-12 row d-flex ">

                    <div class="col-4 flex-column pt-3">
                      <div class="d-flex flex-column">
                        <span class="name">
                          Co-Admin Name
                        </span>

                        <span class="details">
                          {{fullname2}}
                        </span>
                      </div>

                      <div class="d-flex flex-column pt-4 white-space">
                        <span class="name">
                          Mobile Number
                        </span>
                        <span class="details">
                          +91 {{phoneNumber2}}
                        </span>
                      </div>
                    </div>
                    <div class="col-6 flex-column pt-3">
                      <div class="d-flex flex-column white-space">
                        <span class="name">
                          Email Id
                        </span>
                        <span class="details">
                          {{emailId2 | lowercase}}
                        </span>
                      </div>

                      <div class="d-flex flex-column pt-3 white-space">
                        <span class="name">
                          Department
                        </span>
                        <span class="details">
                          {{departmentName2}}
                        </span>
                      </div>

                    </div>
                    <div class="col-2 pl-4" style="margin: auto;">
                      <div class="profil-pic-holder"
                        [style.background-color]="(coAdmin2?.profileUrl != null && coAdmin2?.profileUrl != '') ? '#fff': '#d2edf0'">
                        <img *ngIf="coAdmin2?.profileUrl != null && coAdmin2?.profileUrl != ''"
                          [src]="(coAdmin2?.profileUrl == null || coAdmin2?.profileUrl == '') ? '/assets/images/profile/default-user.png' : coAdmin2?.profileUrl"
                          alt="coadmin profile image">
                        <div class="profil-pic-initial">
                          <span
                            *ngIf="initials2 != '' && (coAdmin2?.profileUrl == null || coAdmin2?.profileUrl !== '')">{{initials2}}</span>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div>
                    <div class="">
                      <div class="line "></div>
                    </div>
                    <div class="mt-3">
                      <div class=" admin">
                        Access
                      </div>
                      <div class="entry-gate pt-3" *ngIf="accessPointList?.list.length > 0"> Entry Gate</div>
                    </div>
                    <div class="mt-4" *ngIf="accessPointList?.list.length > 0">
                      <div class="pl-3 row d-flex mt-3 mr-3">
                        <ng-container class="" *ngFor="let mr of entryGate;let i=index">
                          <div class="chip" [ngClass]="(mr.selected)?'chip-selected':'chip-deselected'">
                            {{mr.accessPoint.accessPointName}}
                            <!-- <span class="closebtn">&times;</span> -->
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div class=" show-all pt-3 pointer-link" (click)="showAccess(false)"
                      [className]="accessPointList?.list.length > 0 ? 'enabled': 'disabled' ">Show all Access
                      ({{accessPointList?.list.length}})
                    </div>

                    <div class="">
                      <div class="line "></div>
                    </div>
                    <div class="pt-4" *ngIf="isAdmin == '1'">
                      <span>
                        <button type="button " class="add-button"
                          (click)="addClick('edit',2, $event);drawerClick(2)"><span class="add">Edit</span></button>
                      </span>
                      <button type="button " class="cancel-button pl-3"><span class="cancel"
                          (click)="drawerClick(null);removeCoAdmin(2)">Remove Co-Admin
                          2</span></button>
                    </div>
                  </div>
                </div>

              </div>


            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      <div>
        <label class="admin">More Details</label>
        <div class="row col-12 d-flex" style="margin-bottom:5%">
          <div class="mask mr-3 mb-3">
            <div class="p-3">
              <div class="room-type">
                Room Type
              </div>
              <div class="all pt-3">
                {{moreDetails?.roomType}}
              </div>
            </div>
          </div>
          <div class="mask mr-3 mb-3">
            <div class="p-3">
              <div class="room-type">
                Credit points Used
              </div>
              <div class="all pt-3">
                {{moreDetails?.creditPointUsed}}/{{moreDetails?.creditPointAllocated}}
              </div>
            </div>
          </div>
          <div class="mask mr-3 mb-3">
            <div class="p-3">
              <div class="room-type">
                2 Wheeler Parking
              </div>
              <div class="all pt-3">
                {{moreDetails?.twoWheelParking}}
              </div>
            </div>
          </div>
          <div class="mask mr-3 mb-3">
            <div class="p-3">
              <div class="room-type">
                4 Wheeler Parking
              </div>
              <div class="all pt-3">
                {{moreDetails?.fourWheelParking}}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>



  </div>


</div>
<div>
  <ng-template #adminAccess let-modal class="text-center custom-class" id="access">
    <div class="modal-height custom-class">
      <div class="modal-body c2 scroll-position">
        <img class="close pointer-link" src="/assets/images/close-modal.png" (click)="modal.close('Save click')"
          loading="lazy" />

        <label class="admin">Access
        </label>
        <div class="entry-gate">Entry Gate</div>
        <div class="pl-3 row d-flex mt-3 mr-3">
          <ng-container class="" *ngFor="let eg of entryGate;let i=index">
            <div class="chip" [ngClass]="(eg.selected)?'chip-selected':'chip-deselected'"
              (click)="changeAccess(eg,'entryGate',i)">
              {{eg.accessPoint.accessPointName}}
              <!-- <span class="closebtn" (click)="changeAccess(eg,'entryGate', i, true)">&times;</span> -->
            </div>
          </ng-container>

        </div>
        <div class="entry-gate pt-3">Meeting Room Access</div>
        <div class="pl-3 row d-flex mt-3 mr-3">
          <ng-container class="" *ngFor="let mr of meetingRoomAccess;let i=index">
            <div class="chip" [ngClass]="(mr.selected)?'chip-selected':'chip-deselected'"
              (click)="changeAccess(eg,'meetingRoomAccess',i)">
              {{mr.accessPoint.accessPointName}}
              <!-- <span class="closebtn" (click)="changeAccess(mr,'meetingRoomAccess', i, true)">&times;</span> -->
            </div>
          </ng-container>


        </div>
        <div class="entry-gate pt-3">Desk Access</div>
        <div class="pl-3 row d-flex mt-3 mr-3">
          <ng-container class="" *ngFor="let mr of deskAccess;let i=index">
            <div class="chip" [ngClass]="(mr.selected)?'chip-selected':'chip-deselected'"
              (click)="changeAccess(eg,'deskAccess',i)">
              {{mr.accessPoint.accessPointName}}
              <!-- <span class="closebtn" (click)="changeAccess(mr,'deskAccess', i, true)">&times;</span> -->
            </div>
          </ng-container>


        </div>
        <div class="entry-gate pt-3">Private Suite Access</div>
        <div class="pl-3 row d-flex mt-3 mr-3">
          <ng-container class="" *ngFor="let mr of privateSuiteAccess;let i=index">
            <div class="chip" [ngClass]="(mr.selected)?'chip-selected':'chip-deselected'"
              (click)="changeAccess(eg,'privateSuiteAccess',i)">
              {{mr.accessPoint.accessPointName}}
              <!-- <span class="closebtn" (click)="changeAccess(mr,'privateSuiteAccess', i, true)">&times;</span> -->
            </div>
          </ng-container>


        </div>

      </div>
    </div>
  </ng-template>
